<template>
  <generic-modal
    v-bind="$props"
    :value="value"
    :title="`Translate ${setPlural(translatingPages.length, 'Page')}`"
    hide-louis
    persistent
    v-on="$listeners"
  >
    <v-container>
      <v-row>
        <v-col>
          <div>Are you sure you want to translate this content?</div>
          <ul>
            <li>
              If a page does not already exist, a new draft page will be created with the translation.
            </li>
            <li>Existing pages will have translated content added under the 'Revisions' tab.</li>
            <li class="red--text">Any revisions on existing pages will be <b>overwritten</b>.</li>
            <li v-if="parentPage.meta.headline" class="mt-6 font-weight-bold">{{ parentPage.meta.headline }}</li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="text-caption mb-4">Translating from:</div>
          <div class="d-flex align-center">
            <flag-pip :flag="parentPage.language.flag" :text="parentPage.language.name" class="mr-2" show-tooltip />
            <base-chip :text="parentPage.site.hostname" label small dark color="grey darken-2" />
          </div>
        </v-col>
        <v-col cols="2">
          <v-icon color="cyan" size="80">double_arrow</v-icon>
        </v-col>
        <v-col>
          <div class="text-caption mb-4">Translating to:</div>
          <div v-for="page in translatingPages" :key="page.id" class="d-flex align-center mb-4">
            <flag-pip :flag="page.language.flag" :text="page.language.name" class="mr-2" show-tooltip />
            <base-chip :text="page.site.hostname" label small dark color="grey darken-2" class="mr-2" />
            <v-tooltip color="grey darken-4" bottom small>
              <template #activator="{ on }">
                <v-icon v-if="page.is_revised" color="warning" v-on="on">rate_review</v-icon>
              </template>
              <span>This page contains revisions that will be overwritten!</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </generic-modal>
</template>

<script>
// Components
import BaseChip from '@/components/chips/base-chip'
import FlagPip from '@/views/news-articles/components/flag-pip'
import GenericModal from '@/components/modals/generic-modal'
// Services
import setPlural from '@/utils/set-plural'

export default {
  name: 'TranslateModal',
  components: {
    BaseChip,
    FlagPip,
    GenericModal,
  },
  extends: GenericModal,
  props: {
    parentPage: {
      type: Object,
      required: true,
    },
    translatingPages: {
      type: Array,
      required: true,
    },
  },
  methods: { setPlural },
}
</script>
